<script>
import { EventBus } from "@/hermeneus.eventbus/eventbus.js";

export default {
  name: "uebungen-library-curated-uebung-card",
  props: {
    uebung: {
      type: Object,
      required: true
    },
    categoryColor: {
      type: String,
      default: "#4CAF50"
    }
  },
  data() {
    return {
      isAnimating: false
    };
  },
  computed: {
    resolvedUebung() {
      return this.$resolveUebungFromRegistry(this.uebung.uebung_type);
    },
    uebungTitle() {
      return this.uebung.specific_uebung?.title || "Unbenannte Übung";
    },
    uebungDescription() {
      return this.uebung.specific_uebung?.description || null;
    }
  },
  methods: {
    openAbsolveModal(event) {
      const button = event.currentTarget;
      const rect = button.getBoundingClientRect();
      const position = {
        x: rect.left + (rect.width / 2),
        y: rect.top + (rect.height / 2)
      };

      this.isAnimating = true;
      setTimeout(() => {
        this.isAnimating = false;
      }, 300);

      EventBus.$emit('uebungen-library__open-absolve-modal', {
        uebung: this.uebung,
        position: position
      });
    },
    openPrintModal(event) {
      event.preventDefault();
      event.stopPropagation();

      const button = event.currentTarget;
      const rect = button.getBoundingClientRect();
      const position = {
        x: rect.left + (rect.width / 2),
        y: rect.top + (rect.height / 2)
      };

      this.isAnimating = true;

      setTimeout(() => {
        EventBus.$emit('uebungen-library__open-print-uebung-modal', {
          uebung: this.uebung,
          position: position
        });

        setTimeout(() => {
          this.isAnimating = false;
        }, 300);
      }, 200);
    }
  }
}
</script>

<template>
  <div class="curated-uebung-row">
    <!-- Left: Title + Description -->
    <div class="curated-uebung-row__content">
      <span class="text-base font-semibold text-grey-800 leading-tight">
        {{ uebungTitle }}
      </span>
      <div v-if="uebungDescription" class="curated-uebung-row__desc text-sm text-grey-500">
        {{ uebungDescription }}
      </div>
    </div>

    <!-- Right: Buttons -->
    <div class="flex items-center gap-1.5 flex-shrink-0 ml-3">
      <button
        @click="openAbsolveModal"
        :disabled="!resolvedUebung?.options?.is_absolvable"
        :class="{ 'button-clicked': isAnimating, 'opacity-30 cursor-not-allowed': !resolvedUebung?.options?.is_absolvable }"
        class="w-8 h-8 text-white rounded-full flex items-center justify-center transition-all duration-200 hover:scale-110"
        :style="{ backgroundColor: categoryColor }">
        <i class="fas fa-play text-xs"></i>
      </button>
      <button
        @click="openPrintModal"
        :disabled="!resolvedUebung?.options?.is_printable"
        :class="{ 'opacity-30 cursor-not-allowed': !resolvedUebung?.options?.is_printable }"
        class="w-8 h-8 border border-grey-300 text-grey-400 rounded-full flex items-center justify-center transition-all duration-200 hover:scale-110 hover:border-grey-500 hover:text-grey-600">
        <i class="fas fa-print text-xs"></i>
      </button>
    </div>
  </div>
</template>

<style scoped>
.curated-uebung-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.625rem 1.25rem;
  border-bottom: 1px solid;
  border-color: rgb(var(--grey-100));
  transition: background-color 0.2s ease;
  cursor: pointer;
}

.curated-uebung-row:hover {
  background-color: rgb(var(--grey-50));
}

.curated-uebung-row:last-child {
  border-bottom: none;
}

.curated-uebung-row__content {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  min-width: 0;
  flex: 1;
}

.curated-uebung-row__desc {
  height: 0;
  opacity: 0;
  overflow: hidden;
  transition: height 0.3s ease, opacity 0.3s ease;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  line-height: 1.25rem;
}

.curated-uebung-row:hover .curated-uebung-row__desc {
  height: 1.25rem;
  opacity: 1;
}

.button-clicked {
  transform: scale(0.9);
}
</style>
